<template>
    <b-col cols="8" offset-md="3">
      <b-alert :show="showErrorAlta" dismissible @dismissed="showErrorAlta = false" variant="danger">Error al dar de alta la
        base {{ model.schema_name }}: {{ response.msg }}</b-alert>
      <b-alert :show="showOkAlta" dismissible @dismissed="showOkAlta = false" variant="success">La base
        {{ model.schema_name }} se dio de alta correctamente.</b-alert>
      <b-alert :show="showOkAltaPDF" dismissible @dismissed="showOkPDFAlta = false" variant="success">Se cargo la informacion
        correctamente en {{ model.schema_name }}.</b-alert>
      <b-alert :show="showErrorAltaPDF" dismissible @dismissed="showErrorAltaPDF = false" variant="danger">Hubo un problema en cargar 
        los datos en {{ model.schema_name }}: {{ response.msg }}</b-alert>

    <!-- Aquí va tu modal -->
    <b-modal v-model="showModal" title="Editar Información de la Empresa">
      <b-form @submit.prevent="onEditSubmit">
        <b-form-group label="Razón Social">
          <b-form-input v-model="empresaEdit.razon_social" :value="this.empresaEdit.razon_social"></b-form-input>
        </b-form-group>

        <b-form-group label="CUIT">
          <b-form-input v-model="empresaEdit.cuit" :value="this.empresaEdit.cuit"></b-form-input>
        </b-form-group>

        <b-form-group label="Domicilio">
          <b-form-input v-model="empresaEdit.domicilio" :value="this.empresaEdit.domicilio"></b-form-input>
        </b-form-group>

        <b-form-group label="Localidad">
          <b-form-input v-model="empresaEdit.localidad" :value="this.empresaEdit.localidad"></b-form-input>
        </b-form-group>

        <b-form-group label="Provincia">
          <b-form-input v-model="empresaEdit.provincia" :value="this.empresaEdit.provincia"></b-form-input>
        </b-form-group>

        <b-form-group label="Código Postal">
          <b-form-input v-model="empresaEdit.cod_postal" :value="this.empresaEdit.cod_postal"></b-form-input>
        </b-form-group>

        <b-form-group label="Inicio de Actividad">
          <b-form-input v-model="empresaEdit.inicio_actividad"></b-form-input>
        </b-form-group>

        <div v-if="Array.isArray(empresaEdit.actividades)">
        <b-form-group
          v-for="(actividad, index) in empresaEdit.actividades"
          :key="index"
          :label="'Actividad ' + (index + 1)">
          <b-form-input v-model="empresaEdit.actividades[index]" placeholder="Ingresa la actividad"></b-form-input>
        </b-form-group>
      </div>



        <b-button @click="showModal = false" type="submit" variant="primary">Guardar cambios y enviar</b-button>
      </b-form>
    </b-modal>


      <b-row class="justify-content-center">
        <b-card title="Subir archivos con datos" class="w-100 mt-4 p-3">
          <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-large rounded="sm">
            <b-form id="formID" @submit.prevent="onSubmit" method="POST" class="form-row needs-validation" ref="formID">
  
  
              <div class="w-100"></div>
  
              <div class="w-100"></div>
  
              <b-form-group class="col-md-4 col-sm-6">
                <label for="archivo">Cargar archivos PDF</label>
                <b-form-file id="archivo" accept=".pdf" @change="onFileChange" ref="fileInput" required></b-form-file>
              </b-form-group>
  
              <b-form-group class="col-md-4 col-sm-6">
                <label for="descripcion">Nombre Tecnico BDD</label>
                <b-form-input id="descripcion" v-model="model.schema_name" placeholder="Ingresa una base de datos"
                  required></b-form-input>
              </b-form-group>
  
              <b-form-group class="col-md-4 col-sm-6">
                <label for="descripcion">Ingresar codigo empresa</label>
                <b-form-input id="descripcion" v-model="model.emp_code" placeholder="Ingresa una base de datos"
                  required></b-form-input>
              </b-form-group>
  
  
              <div class="w-100"></div>
  
              <div class="w-100">
              </div>
  
  
              <b-button type="submit" size="lg" variant="outline-primary">Enviar</b-button>
  
  
  
            </b-form>
          </b-overlay>
  
        </b-card>
      </b-row>
  
    </b-col>
  
  </template>
  
  <script>
  import { TokenService } from "../storage/service"
  
  export default {
    name: 'ResetPassword',
    props: {
      msg: String
    },
    data: function () {
      return {
        model: {
          schema_name: '',
          emp_code: '',
          files: null,
          response: {},
        },
        empresaEdit: {
        razon_social: '',
        cuit: '',
        domicilio: '',
        localidad: '',
        provincia: '',
        cod_postal: '',
        inicio_actividad: '',
        actividades: [],
      },
        loading: false,
        showErrorAlta: false,
        showOkAlta: false,
        showOKAltaPDF: false,
        showErrorAltaPDF: false,
        response: {},
        submitted: false, 
        showModal: false,
      };
    },
    mounted() {
      this.login();
  
    },
  
    methods: {
      login() {
        let token = TokenService.getToken()
        this.$http.post(this.backendURL + 'api/v1.0/checkSession/', { headers: { 'Authorization': 'Token ' + token } })
          .then(() => {
            console.log("Token Correcto")
          })
          .catch(err => {
            // catch error});
            if (err.request.statusText == 'Unauthorized') {
              alert("Su sesion ha expirado...")
              this.$store.dispatch('logout')
                .then(() => {
                  this.$router.push('/login')
                })
            }
            else {
              console.log(err.data)
            }
          })
      },
      async onSubmit() {
        // Valida si hay algun field invalido
        let tokenpdf = TokenService.getTokenPDF()     
        this.submitted = true
  
        if (!this.model.schema_name || !this.model.emp_code || !this.model.file) {
          this.showErrorAlta = true;
          this.response.msg = "Todos los campos son obligatorios";
          return;
        }
        
        const formData = new FormData();
        formData.append('file', this.model.file);
        formData.append('schema_name', this.model.schema_name);
        formData.append('emp_code', this.model.emp_code);
  
        this.loading = true
  
        try {
          const res = await this.$http.post(this.backendURLPDF + 'experiencia/empresa', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${tokenpdf}` // Reemplaza con tu token de autenticación
            }
          })
          console.log(res.data)
          console.log(res.data.actividades)
          // Guardamos la respuesta y mostramos el modal

          // Asegúrate de que la respuesta sea JSON
        if (typeof res.data === 'string') {
        try {
          this.response = JSON.parse(res.data); // Convierte la cadena en un objeto JSON
        } catch (parseError) {
          console.error("Error parsing JSON:", parseError);
          this.showErrorAltaPDF = true;
          return;
        }
        } else {
          this.response = res.data;
        }
        console.log(typeof this.response.actividades)
        this.empresaEdit = {
          razon_social: this.response.razon_social,
          cuit: this.response.cuit,
          domicilio: this.response.domicilio,
          localidad: this.response.localidad,
          provincia: this.response.provincia,
          cod_postal: this.response.cod_postal,
          inicio_actividad: this.response.inicio_actividad,
          actividades: this.response.actividades,
        };

        this.showModal = true; // Muestra el modal
        } catch (error) {
          console.log(error)
          this.showErrorAltaPDF = true;
        } finally {
          this.loading = false;
        }
  
      
  
        
  
      },

          // Manejar el envío del formulario del modal
    async onEditSubmit() {
      let tokenpdf = TokenService.getTokenPDF()  
      const updatedData = {
        razon_social: this.empresaEdit.razon_social,
        cuit: this.empresaEdit.cuit,
        domicilio: this.empresaEdit.domicilio,
        localidad: this.empresaEdit.localidad,
        provincia: this.empresaEdit.provincia,
        cod_postal: this.empresaEdit.cod_postal,
        inicio_actividad: this.empresaEdit.inicio_actividad,
        actividades: this.empresaEdit.actividades, // Convertir de string a array
      };
      console.log("updated data")
      const formData = new FormData();
      formData.append('schema_name', this.model.schema_name);
      formData.append('emp_code', this.model.emp_code);
      formData.append('razon_social', updatedData.razon_social);
      formData.append('cuit', updatedData.cuit);
      formData.append('domicilio', updatedData.domicilio);
      formData.append('localidad', updatedData.localidad);
      formData.append('provincia', updatedData.provincia);
      formData.append('cod_postal', updatedData.cod_postal);
      formData.append('inicio_actividad', updatedData.inicio_actividad);
      // Enviar cada actividad en el campo 'actividades'
      updatedData.actividades.forEach((value) => {
        formData.append('actividades', value);
      });
      console.log(formData)
      try {
        const res = await this.$http.post(this.backendURLPDF + 'experiencia/actualizar-empresa', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${tokenpdf}` // Reemplaza con tu token de autenticación
            }
        })
        console.log(res)
        ;}
//      console.log
      //  console.log("Datos actualizados con éxito:", res.data);
      //  this.showModal = false; // Cerrar modal después de enviar
      catch (error) {
        console.error("Error al actualizar los datos:", error);
        
      //}
    }},
  
      onFileChange(event) {
        this.model.file = event.target.files[0];
      },
      
  
      catchError(err) {
        if (err.request.statusText == 'Unauthorized') {
          alert("Su sesion ha expirado...")
          this.$store.dispatch('logout')
            .then(() => {
              this.$router.push('/login')
            })
        }
        else {
          console.log(err.data)
        }
      }
    },
  
    computed: {
      schemaNameState() {
        return this.submitted ? (this.model.schema_name ? true : false) : null;
      },
      empCodeState() {
        return this.submitted ? (this.model.emp_code ? true : false) : null;
      }
    },
  
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 25px 0 25px 0;
  }
  
  #formID {
    padding: 20px;
  }
  </style>
  